import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Caption } from "@jsluna/typography";
import SectionContainer from "./SectionContainer";
import {
  Preferences,
  RadioButtonInputField,
} from "@jsainsburyplc/id-ui-common";

import { loadConsents } from "actions/cpm.actions";
import prefSelectOptions from "./prefSelectOptions";
import { CONSENT_ALL } from "constants/registrationForm";

const MarketingPreferences = ({
  preferencesData: { label, elements, separator },
  loadConsents,
  consents,
  error,
  setFieldValue,
  consentAll,
  userEmail,
}) => {
  const [showPrefs, setShowPrefs] = useState(false);

  useEffect(() => {
    loadConsents(userEmail);
  }, [loadConsents, userEmail]);

  useEffect(() => {
    if (consents) {
      consents.consents.forEach((item) => {
        setFieldValue(
          `preferences.${item.mission}`,
          item.consent === "Y" ? true : false
        );
      });
      setShowPrefs(true);
    }
  }, [consents, error, setFieldValue]);

  return (
    <SectionContainer label={label}>
      <p>
        As a valued customer, we'd love to stay in touch with you with things
        like offers and ideas. Please be assured, we'll always treat your
        information carefully as described in our privacy policy.{" "}
      </p>
      <p>
        Would you like to hear about offers and ideas from the Sainsbury's
        Group*, whether it's through the post, by email, text message or by any
        other electronic means?
      </p>
      <RadioButtonInputField
        name={CONSENT_ALL}
        label=""
        listType="inline"
        options={[
          { value: "Y", label: "Yes" },
          {
            value: "N",
            label: "No",
            defaultChecked: true,
          },
        ]}
      />
      {showPrefs && (
        <div style={{ display: consentAll === "Y" ? "none" : "block" }}>
          <p>
            Just select the individual parts of the Sainsbury's Group you want
            to hear from.
          </p>
          <Preferences items={prefSelectOptions} />
          <Caption>
            <p>
              We won't send you marketing messages if you tell us not to, but we
              will still need to send you occasional service-related messages.
            </p>
            <p>
              *Sainsbury's Group includes Sainsbury's, Argos, Sainsbury's Bank,
              Argos Financial Services, Tu Clothing and Habitat.
            </p>
            <p> Your preferences will apply to {userEmail}.</p>
          </Caption>
        </div>
      )}
    </SectionContainer>
  );
};

const mapStateToProps = (state) => ({
  consents: state.cpm.consents,
  error: state.cpm.error,
});

const mapDispatchToProps = {
  loadConsents,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MarketingPreferences)
);
